/** GENERATED by TOWNS/tools/build_props.py - do not edit by hand.
 *
 * The drawn canvas size of every prop sprite, per faction. `townProps.ts`
 * needs a prop's size to lay a row of them out in the gap between two
 * buildings, and it is a pure module: it cannot ask the atlas. The sprite
 * ships at `w * TOWN_HD` pixels (build_props.py), the same hi-def contract
 * the buildings ship under, and the screen draws it at `w`.
 */

export interface PropArt {
  /** Atlas key suffix: `town.<faction>.prop.<key>`. */
  readonly key: string;
  /** Drawn width and height on the 1280x720 canvas, at stand scale 1. */
  readonly w: number;
  readonly h: number;
}

export const TOWN_PROP_ART: Readonly<Record<string, readonly PropArt[]>> = Object.freeze({

  sunspire: Object.freeze([
    { key: "stall", w: 46.0, h: 34.7 },
    { key: "haycart", w: 44.0, h: 31.3 },
    { key: "well", w: 30.0, h: 27.3 },
    { key: "tent", w: 44.0, h: 28.7 },
    { key: "fence", w: 48.0, h: 26.0 },
    { key: "barrels", w: 30.0, h: 17.3 },
    { key: "brazier", w: 20.0, h: 40.7 },
    { key: "statue", w: 26.0, h: 33.3 },
    { key: "haystack", w: 32.0, h: 25.3 },
    { key: "signpost", w: 22.0, h: 22.7 },
    { key: "hedge", w: 42.0, h: 27.3 },
    { key: "trough", w: 28.0, h: 11.3 },
  ]),
  greenmantle: Object.freeze([
    { key: "totem", w: 20.0, h: 28.7 },
    { key: "flowercart", w: 40.0, h: 37.3 },
    { key: "runestone", w: 26.0, h: 26.0 },
    { key: "mushrooms", w: 28.0, h: 20.0 },
    { key: "rail", w: 46.0, h: 29.3 },
    { key: "lantern", w: 20.0, h: 25.3 },
    { key: "logs", w: 34.0, h: 24.0 },
    { key: "ferns", w: 32.0, h: 30.0 },
    { key: "anvil", w: 26.0, h: 19.3 },
    { key: "basket", w: 22.0, h: 16.7 },
    { key: "birdbath", w: 26.0, h: 20.0 },
    { key: "beehive", w: 20.0, h: 19.3 },
  ]),
  skyreach: Object.freeze([
    { key: "orb", w: 22.0, h: 34.0 },
    { key: "armillary", w: 28.0, h: 43.3 },
    { key: "telescope", w: 26.0, h: 32.7 },
    { key: "obelisk", w: 22.0, h: 30.7 },
    { key: "lectern", w: 24.0, h: 26.0 },
    { key: "banner", w: 20.0, h: 27.3 },
    { key: "cauldron", w: 26.0, h: 30.7 },
    { key: "lamp", w: 18.0, h: 32.0 },
    { key: "bench", w: 34.0, h: 22.0 },
    { key: "crates", w: 28.0, h: 21.3 },
    { key: "wall", w: 46.0, h: 28.0 },
    { key: "brazier", w: 20.0, h: 22.7 },
  ]),
  emberpit: Object.freeze([
    { key: "brazier", w: 22.0, h: 29.3 },
    { key: "bonetotem", w: 22.0, h: 33.3 },
    { key: "boulder", w: 34.0, h: 25.3 },
    { key: "cage", w: 24.0, h: 38.0 },
    { key: "weapons", w: 30.0, h: 29.3 },
    { key: "skulls", w: 26.0, h: 21.3 },
    { key: "firepit", w: 34.0, h: 25.3 },
    { key: "pillar", w: 22.0, h: 26.0 },
    { key: "gate", w: 44.0, h: 46.0 },
    { key: "cauldron", w: 26.0, h: 28.0 },
    { key: "deadtree", w: 34.0, h: 34.7 },
    { key: "bannerpole", w: 20.0, h: 20.7 },
  ]),
  gravewatch: Object.freeze([
    { key: "gravestone", w: 18.0, h: 19.3 },
    { key: "sarcophagus", w: 40.0, h: 24.7 },
    { key: "ironfence", w: 46.0, h: 40.0 },
    { key: "urn", w: 20.0, h: 17.3 },
    { key: "deadtree", w: 36.0, h: 37.3 },
    { key: "graves", w: 30.0, h: 26.7 },
    { key: "cross", w: 20.0, h: 23.3 },
    { key: "lantern", w: 18.0, h: 34.7 },
    { key: "bones", w: 28.0, h: 16.7 },
    { key: "angel", w: 24.0, h: 18.0 },
    { key: "crypt", w: 34.0, h: 16.7 },
    { key: "perch", w: 18.0, h: 18.7 },
  ]),
  deepvault: Object.freeze([
    { key: "crystals", w: 30.0, h: 22.7 },
    { key: "stalagmite", w: 22.0, h: 22.0 },
    { key: "brazier", w: 22.0, h: 25.3 },
    { key: "cage", w: 24.0, h: 36.0 },
    { key: "idol", w: 22.0, h: 23.3 },
    { key: "hoard", w: 28.0, h: 10.7 },
    { key: "spears", w: 28.0, h: 29.3 },
    { key: "pillar", w: 22.0, h: 20.0 },
    { key: "fungus", w: 28.0, h: 18.0 },
    { key: "basin", w: 24.0, h: 16.0 },
    { key: "grate", w: 40.0, h: 27.3 },
    { key: "orecart", w: 34.0, h: 24.0 },
  ]),
  ironhorde: Object.freeze([
    { key: "totem", w: 22.0, h: 29.3 },
    { key: "palisade", w: 46.0, h: 44.7 },
    { key: "campfire", w: 34.0, h: 23.3 },
    { key: "weapons", w: 30.0, h: 26.0 },
    { key: "hides", w: 28.0, h: 25.3 },
    { key: "drum", w: 26.0, h: 24.0 },
    { key: "skull", w: 40.0, h: 25.3 },
    { key: "banner", w: 20.0, h: 28.0 },
    { key: "rockcart", w: 38.0, h: 26.7 },
    { key: "boulders", w: 34.0, h: 22.7 },
    { key: "meatrack", w: 30.0, h: 16.0 },
    { key: "alebarrel", w: 28.0, h: 20.0 },
  ]),
  fenmire: Object.freeze([
    { key: "pierpost", w: 16.0, h: 24.0 },
    { key: "net", w: 40.0, h: 30.7 },
    { key: "baskets", w: 26.0, h: 25.3 },
    { key: "boglantern", w: 18.0, h: 26.7 },
    { key: "driftwood", w: 34.0, h: 20.7 },
    { key: "oven", w: 28.0, h: 22.0 },
    { key: "fishrack", w: 30.0, h: 22.0 },
    { key: "crocskull", w: 22.0, h: 28.0 },
    { key: "coracle", w: 34.0, h: 26.0 },
    { key: "mossstone", w: 30.0, h: 16.0 },
    { key: "stilts", w: 36.0, h: 26.7 },
    { key: "reeds", w: 30.0, h: 31.3 },
  ]),
  prismgate: Object.freeze([
    { key: "runestone", w: 22.0, h: 25.3 },
    { key: "fountain", w: 30.0, h: 33.3 },
    { key: "whiteflame", w: 28.0, h: 23.3 },
    { key: "shards", w: 26.0, h: 21.3 },
    { key: "whirl", w: 24.0, h: 26.7 },
    { key: "obelisk", w: 22.0, h: 31.3 },
    { key: "orbs", w: 24.0, h: 36.0 },
    { key: "bell", w: 26.0, h: 24.7 },
    { key: "flowers", w: 34.0, h: 22.7 },
    { key: "arch", w: 32.0, h: 18.7 },
    { key: "pool", w: 36.0, h: 14.0 },
    { key: "lanternorb", w: 18.0, h: 34.7 },
  ]),
  saltreach: Object.freeze([
    { key: "cargo", w: 34.0, h: 24.7 },
    { key: "bollard", w: 18.0, h: 14.0 },
    { key: "net", w: 38.0, h: 30.7 },
    { key: "dinghy", w: 42.0, h: 23.3 },
    { key: "traps", w: 26.0, h: 18.7 },
    { key: "lantern", w: 18.0, h: 30.0 },
    { key: "fishstall", w: 44.0, h: 35.3 },
    { key: "capstan", w: 26.0, h: 19.3 },
    { key: "anchor", w: 30.0, h: 26.0 },
    { key: "parasol", w: 32.0, h: 28.7 },
    { key: "powder", w: 26.0, h: 16.7 },
    { key: "signpost", w: 22.0, h: 34.7 },
  ]),
  cogworks: Object.freeze([
    { key: "drums", w: 28.0, h: 27.3 },
    { key: "boiler", w: 32.0, h: 28.7 },
    { key: "handcart", w: 36.0, h: 20.7 },
    { key: "partscrate", w: 26.0, h: 18.0 },
    { key: "manifold", w: 30.0, h: 20.7 },
    { key: "vent", w: 20.0, h: 23.3 },
    { key: "toolrack", w: 28.0, h: 21.3 },
    { key: "coal", w: 30.0, h: 14.0 },
    { key: "gears", w: 28.0, h: 14.7 },
    { key: "lamp", w: 18.0, h: 40.7 },
    { key: "tank", w: 32.0, h: 32.0 },
    { key: "scrap", w: 32.0, h: 17.3 },
  ]),
  frostmark: Object.freeze([
    { key: "prow", w: 34.0, h: 28.7 },
    { key: "firewood", w: 32.0, h: 18.7 },
    { key: "runestone", w: 24.0, h: 22.0 },
    { key: "fishrack", w: 32.0, h: 22.7 },
    { key: "shields", w: 30.0, h: 16.0 },
    { key: "firepit", w: 32.0, h: 24.0 },
    { key: "barrels", w: 28.0, h: 22.0 },
    { key: "mast", w: 22.0, h: 18.0 },
    { key: "whalebone", w: 30.0, h: 20.7 },
    { key: "sledge", w: 34.0, h: 20.0 },
    { key: "mooring", w: 18.0, h: 17.3 },
    { key: "icestack", w: 26.0, h: 14.7 },
  ]),
  blackwater: Object.freeze([
    { key: "pierpost", w: 16.0, h: 19.3 },
    { key: "net", w: 38.0, h: 44.7 },
    { key: "crabtraps", w: 26.0, h: 19.3 },
    { key: "ribarch", w: 32.0, h: 16.7 },
    { key: "greenlantern", w: 18.0, h: 24.7 },
    { key: "shells", w: 26.0, h: 12.0 },
    { key: "rowboat", w: 40.0, h: 24.0 },
    { key: "eelrack", w: 28.0, h: 20.7 },
    { key: "anchor", w: 28.0, h: 26.0 },
    { key: "driftwood", w: 32.0, h: 18.0 },
    { key: "totem", w: 22.0, h: 28.7 },
    { key: "algaebarrel", w: 26.0, h: 18.7 },
  ]),
});

/** The four foundations a faction can stand a building on where its painting
 *  gives it none - a bank, a piling deck, a cut rock shelf, a dressed plinth
 *  (props_catalog.FOOTINGS). Shipped at one reference width and scaled by the
 *  screen to the building's own drawn width. */
export const TOWN_FOOTING_ART: Readonly<Record<string, readonly PropArt[]>> = Object.freeze({

  sunspire: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 114.7 },
    { key: "footing_piling", w: 200.0, h: 104.7 },
    { key: "footing_shelf", w: 200.0, h: 88.0 },
    { key: "footing_plinth", w: 200.0, h: 67.3 },
  ]),
  greenmantle: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 81.3 },
    { key: "footing_piling", w: 200.0, h: 92.0 },
    { key: "footing_shelf", w: 200.0, h: 64.7 },
    { key: "footing_plinth", w: 200.0, h: 59.3 },
  ]),
  skyreach: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 95.3 },
    { key: "footing_piling", w: 200.0, h: 112.0 },
    { key: "footing_shelf", w: 200.0, h: 77.3 },
    { key: "footing_plinth", w: 200.0, h: 68.0 },
  ]),
  emberpit: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 90.7 },
    { key: "footing_piling", w: 200.0, h: 110.7 },
    { key: "footing_shelf", w: 200.0, h: 81.3 },
    { key: "footing_plinth", w: 200.0, h: 70.0 },
  ]),
  gravewatch: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 86.7 },
    { key: "footing_piling", w: 200.0, h: 107.3 },
    { key: "footing_shelf", w: 200.0, h: 74.0 },
    { key: "footing_plinth", w: 200.0, h: 66.7 },
  ]),
  deepvault: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 82.7 },
    { key: "footing_piling", w: 200.0, h: 92.0 },
    { key: "footing_shelf", w: 200.0, h: 72.7 },
    { key: "footing_plinth", w: 200.0, h: 64.7 },
  ]),
  ironhorde: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 82.7 },
    { key: "footing_piling", w: 200.0, h: 104.7 },
    { key: "footing_shelf", w: 200.0, h: 75.3 },
    { key: "footing_plinth", w: 200.0, h: 70.7 },
  ]),
  fenmire: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 78.7 },
    { key: "footing_piling", w: 200.0, h: 104.7 },
    { key: "footing_shelf", w: 200.0, h: 74.0 },
    { key: "footing_plinth", w: 200.0, h: 58.0 },
  ]),
  prismgate: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 84.7 },
    { key: "footing_piling", w: 200.0, h: 86.0 },
    { key: "footing_shelf", w: 200.0, h: 72.7 },
    { key: "footing_plinth", w: 200.0, h: 60.0 },
  ]),
  saltreach: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 77.3 },
    { key: "footing_piling", w: 200.0, h: 109.3 },
    { key: "footing_shelf", w: 200.0, h: 103.3 },
    { key: "footing_plinth", w: 200.0, h: 68.7 },
  ]),
  cogworks: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 80.7 },
    { key: "footing_piling", w: 200.0, h: 92.0 },
    { key: "footing_shelf", w: 200.0, h: 71.3 },
    { key: "footing_plinth", w: 200.0, h: 61.3 },
  ]),
  frostmark: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 84.7 },
    { key: "footing_piling", w: 200.0, h: 112.0 },
    { key: "footing_shelf", w: 200.0, h: 74.7 },
    { key: "footing_plinth", w: 200.0, h: 66.0 },
  ]),
  blackwater: Object.freeze([
    { key: "footing_bank", w: 200.0, h: 93.3 },
    { key: "footing_piling", w: 200.0, h: 95.3 },
    { key: "footing_shelf", w: 200.0, h: 76.0 },
    { key: "footing_plinth", w: 200.0, h: 66.0 },
  ]),
});
